import { Component, OnInit, Input, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ColumnaTabla } from '../../tabla';

@Component({
	selector: 'tr2-table-options',
	templateUrl: './table-options.component.html',
	styleUrls: ['./table-options.component.scss']
})
export class TableOptionsComponent implements OnInit {

	dataSource: MatTableDataSource<any> = new MatTableDataSource();

	seleccionado: any;

	_columnas: ColumnaTabla[] = [];
	@Input()
	get columnas() {
		return this._columnas;
	}
	set columnas(val) {
		this._columnas = val;
		this.displayColumns = val.length > 0 ? val.map(c => c.def) : [];
		console.log(this.displayColumns);
	}
	displayColumns: string[] = [];

	_resultados: any[] = [];
	@Input()
	get resultados() {
		return this._resultados;
	}

	set resultados(val) {
		this._resultados = val;
		this.dataSource.data = val;
		this.seleccionado = (this.dataSource.data && this.dataSource.data.length) ? this.dataSource.data[0] : null;
	}

	constructor() { }

	ngOnInit() {
	}

	moverCursor(direccion) {
		// console.log('quiere ir a ', direccion, ' y esta en ', this.dataSource.data.indexOf(this.seleccionado), 'y tiene ', this.seleccionado);
		if (direccion == 1) { // Arriba
			const index = this.dataSource.data.indexOf(this.seleccionado);
			if (index) {
				this.seleccionado = this.dataSource.data[(index - 1)];
			} else {
				this.seleccionado = this.dataSource.data[ this.dataSource.data.length - 1 ];
			}
		} else if (direccion == 2) {
			const nextIndex = this.dataSource.data.indexOf(this.seleccionado) + 1;
			if (nextIndex < this.dataSource.data.length) {
				this.seleccionado = this.dataSource.data[nextIndex];
			} else {
				this.seleccionado = this.dataSource.data[0];
			}
		}
		// buscamos la fila para hacer el scroll
		const panel = document.querySelector('.gestionventas .mat-autocomplete-panel');
		setTimeout(() => {
			const row: any = panel.querySelector('.rowSeleccionada');
			if (row) {
				const list = row.parentNode.parentNode.parentNode;
				console.log(list.top >= 0 && list.bottom <= list.innerHeight);
				row.scrollIntoView({ block: 'center', behavior: 'instant' });
			}
		});
	}

	onClick (ev) {
		console.log('onclick en tabla: ', ev);
		ev['porClick'] = true;
		this.seleccionado = ev;
	}
}
